import React from 'react';
import { Button } from 'react-bootstrap';

export default function CodeView({ html, filename }) {
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(html || '');
            alert('HTML скопирован в буфер обмена.');
        } catch {
            alert('Не удалось скопировать.');
        }
    };

    const download = () => {
        const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        const nameBase = (filename || 'document').replace(/\.[^/.]+$/, '');
        a.download = `${nameBase}.html`;
        a.click();
        URL.revokeObjectURL(a.href);
    };

    return (
        <div>
            <div className="d-flex gap-2 mb-2">
                <Button size="sm" variant="secondary" onClick={copy}>Копировать</Button>
                <Button size="sm" onClick={download}>Скачать</Button>
            </div>
            <textarea className="code-area" readOnly value={html || ''} />
        </div>
    );
}